import { useState, createContext, useContext, useEffect } from 'react'
import { DB, REAL_DB } from '../../firebase'
import { useAuthContext } from './AuthContext'
import firebase from 'firebase'
import { tsToDate } from '../utils/tsToDate'

const generalContext = createContext()

export const useGeneralContext = () => useContext(generalContext)

export function GeneralContextProvider({ children }) {
    const [subSelected, setSubSelected] = useState('')
    const [chapterSelected, setChapterSelected] = useState('')
    const [partSelected, setPartSelected] = useState('')
    const [rankListSelected, setRankListSelected] = useState('')
    const [getRankListStatus, setGetRankListStatus] = useState(false)
    const [getOfflineRankListStatus, setGetOfflineRankListStatus] =
        useState(false)
    const [loading, setLoading] = useState(true)
    const [results, setResults] = useState('')
    const [mode, setMode] = useState('online')
    const [offlineRanklist, setOfflineRanklist] = useState([])

    const [examSelected, setExamSelected] = useState('')

    const { userDetails } = useAuthContext()

    async function createTimeStampInDB() {
        await REAL_DB.ref(`timestamps/${userDetails?.uid}`).set({
            timestamp: firebase.database.ServerValue.TIMESTAMP
        })
    }

    function findMark(studentID, rankList) {
        let markRank = { mark: 0, rank: '-' }
        rankList.forEach((st) => {
            if (st?.st_id === studentID) {
                markRank = {
                    mark: st?.st_mark,
                    rank: st?.st_rank
                }
            }
        })
        return markRank
    }

    function getOfflineRanklists() {
        if (!!!userDetails || !!offlineRanklist.length) return

        console.log('getting offline rank list')

        DB.collection('offline_exams')
            .where('batchName', '==', userDetails?.batch.batchName)
            .orderBy('dateOfExam', 'desc')
            .limit(10)
            .onSnapshot((querySnapshot) => {
                var arr = []
                querySnapshot.forEach((doc) => {
                    let isStudentPresent =
                        !!doc
                            .data()
                            .rankList.filter(
                                (item) => item.id === userDetails?.uid
                            ).length > 0
                    if (isStudentPresent)
                        arr.push({
                            id: doc.id,
                            ...doc.data()
                        })
                })
                setOfflineRanklist(arr)
            })
    }

    function dataExtracted(eachReport, id) {
        const markAndRank = findMark(userDetails?.uid, eachReport?.rankList)

        const totalMark = eachReport?.totalMark
        const Date = tsToDate(eachReport?.exam_time)[0]
        const Subject = eachReport?.exam_subject
        const ExamInfo = eachReport?.exam_title
        const mark = markAndRank.mark > -77777 ? markAndRank.mark : 'ABSENT'
        const rank = markAndRank.mark > -77777 ? markAndRank.rank : '--'
        const percentage =
            Math.round((markAndRank.mark / totalMark) * 100) < 0
                ? 0
                : Math.round((markAndRank.mark / totalMark) * 100)

        return {
            subject: Subject,
            title: ExamInfo,
            totalMark: totalMark,
            yourMark: mark,
            percentage: percentage,
            Rank: rank,
            date: Date,
            id: id,
            rankList: eachReport?.rankList
        }
    }

    async function getAllRankList() {
        setLoading(true)
        await DB.collection('rankLists')
            .where('batch', '==', userDetails?.batch?.batchName)
            .orderBy('exam_time', 'desc')
            .limit(5)
            .onSnapshot((querySnapshot) => {
                let arr = []
                querySnapshot.forEach((doc) => {
                    arr.push(dataExtracted(doc.data(), doc.id))
                })
                setResults(arr)
                setLoading(false)
            })
    }

    useEffect(() => {
        !!userDetails && getRankListStatus && getAllRankList()
    }, [userDetails, getRankListStatus])

    useEffect(() => {
        !!userDetails && getOfflineRankListStatus && getOfflineRanklists()
    }, [userDetails, getOfflineRankListStatus])

    const values = {
        subSelected,
        setSubSelected,
        chapterSelected,
        setChapterSelected,
        partSelected,
        setPartSelected,

        examSelected,
        setExamSelected,

        createTimeStampInDB,

        rankListSelected,
        setRankListSelected,

        setGetRankListStatus,
        loading,
        setLoading,
        results,

        mode,
        setMode,
        offlineRanklist,
        setGetOfflineRankListStatus
    }

    return (
        <generalContext.Provider value={values}>
            {children}
        </generalContext.Provider>
    )
}
